import React, { useContext, useEffect, useMemo, useRef, useState } from "react"
import { FullAnalysisCrumbs } from "../dashboardPage/components/fullAnalysis/FullAnalysisCrumbs"
import { FullAnalysisFolderList } from "../dashboardPage/components/fullAnalysis/FullAnalysisFolderList"
import { IAnalysisFolder } from "../dashboardPage/components/fullAnalysis/IAnalysisFolder";
import { AppContext } from "../../appContext";
import { linkGoogleWithPopup } from "../../api/api";
import { IFileProvider } from "../../api/fileProvider/IFileProvider";
import { GFileProvider } from "../../api/fileProvider/gFileProvider";
import { GDriveConnectButton } from "./GDriveConnectButton"
import folder1 from '../../assets/folder_filled.svg';
import { Spinner } from "../../components/spinner/Spinner";
import { FullAnalysisFolderSettings } from "../dashboardPage/components/fullAnalysis/FullAnalysisFolderSettings";
import { FullAnalysisAddFolderPanel } from "../dashboardPage/components/fullAnalysis/FullAnalysisAddFolderPanel";

interface IFileProviderViewerProps {
    FileProvider: {new ():IFileProvider},
    AddPanel?: ({provider, selectedItem}: {provider: IFileProvider, selectedItem: IAnalysisFolder}) => React.ReactNode,
    NotConnectedView?: ({onClick}: {onClick: ()=>void})=>React.ReactElement;
    onSelect?: (item: IAnalysisFolder)=>void,
    callModal?: (modal: (close: ()=>void)=>React.ReactNode)=>void;
}

export const FileProviderViewer = ({onSelect, FileProvider, NotConnectedView, callModal, AddPanel}: IFileProviderViewerProps)=>{
    const [provider, setProvider] = useState<IFileProvider>(null);
    const [selectedItem, setSelectedItem] = useState<IAnalysisFolder>(null);
    const [showSettings, setShowSettings] = useState<IAnalysisFolder>(null);
    const [notConnected, setNotConnected] = useState(false);
    const [inited, setInited] = useState(false);
    const [fix, setFix] = useState(0);

    const crumbs = provider?.crumbs;
    const currentFolder = provider?.crumbs[provider?.crumbs.length-1];
    const fileInputRef = useRef<HTMLInputElement>(null);

    useEffect(()=>{
        const _provider = new FileProvider();
        _provider.onChange = ()=>{
            setFix(last=>last+1);
        }
        _provider.onAuthError = ()=>{
            console.log('not connected');
            setNotConnected(true);
        }
        _provider.onReady = ()=>{
            console.log('g inited');

            _provider.getFiles().then(()=>{
               setInited(true); 
            });
            setProvider(_provider);
        }
    }, []);

    useEffect(()=>{
        console.log(currentFolder);
        onSelect?.(provider && !notConnected && currentFolder && inited && (selectedItem || currentFolder));
    }, [selectedItem, currentFolder, notConnected, provider]);

    const navigateFolder = (folderId?: string)=>{
        provider.getFiles(folderId);
    }

    const handleCrumb = (folder: IAnalysisFolder)=>{
        provider.getFiles(folder.id);
        setSelectedItem(null);
    }

    const handleSelect = (folder: IAnalysisFolder)=>{
        if (selectedItem == folder){
            if (selectedItem?.type == 'folder'){
                navigateFolder(folder.id);
            }
        } else {
            setSelectedItem(folder);    
        }
    }

    const handleAddFolder = ()=>{
        console.log('create folder');
        const newFolder: IAnalysisFolder = {
            name: "test_folder",
            iconIndex: 0,
            date: new Date(),
            type: "folder"
        }
        provider.createFolder(newFolder, currentFolder.id);
    }

    const handleSubmitUploadFile = (file: File)=>{
        provider.createFile(file, currentFolder.id);
    }

    return <div>
        <input ref={fileInputRef} style={{display: 'none'}} type="file" onChange={(e)=>{
            handleSubmitUploadFile(e.target.files[0]);
        }}></input>

        {notConnected && NotConnectedView && <NotConnectedView onClick={()=>{
            provider.connect().then(res=>{
                setNotConnected(false);
                provider.getFiles();
            });
        }}></NotConnectedView>}

        {(!currentFolder || currentFolder.loadingStatus == 'loading') && <Spinner></Spinner>}
        {(!notConnected && crumbs && currentFolder && currentFolder.loadingStatus != 'loading') && 
            <FullAnalysisCrumbs 
                crumbs={crumbs} 
                onCrumb={handleCrumb}
            ></FullAnalysisCrumbs>
        }
        {(!notConnected && currentFolder && currentFolder.loadingStatus != 'loading') && inited && <div><FullAnalysisFolderList 
            folder={currentFolder}
            selectedItem={selectedItem}
            onSelect={handleSelect}
            onRename={(file, name)=>{
                if (file.name != name) {
                    provider.updateFile({...file, name: name});
                }
            }}
            onSettings={(file)=>{
                //setShowSettings(file);
                callModal((close)=>{
                    return <FullAnalysisFolderSettings 
                        folder={file}
                        editableOptions={provider?.providerName == 'g' ? {icon: false} : undefined}
                        onSubmit={(data)=>{
                            close();
                            provider.updateFile({...file, ...data});
                        }}
                        onClose={()=>{close()}}
                    ></FullAnalysisFolderSettings>
                })
            }}
            onDelete={(item)=>{provider.deleteFile(item.id)}}
        ></FullAnalysisFolderList>
        {!AddPanel && <FullAnalysisAddFolderPanel
            onAdd={handleAddFolder}
            onAddFile={()=>{fileInputRef.current.click()}}
        ></FullAnalysisAddFolderPanel>}
        {AddPanel && <AddPanel provider={provider} selectedItem={selectedItem}></AddPanel>}
        </div>}

        {/*showSettings && <FullAnalysisFolderSettings 
            folder={showSettings}
            editableOptions={provider?.providerName == 'g' ? {icon: false} : undefined}
            onSubmit={(data)=>{
                setShowSettings(null);
                provider.updateFile({...showSettings, ...data});
            }}
            onClose={()=>{setShowSettings(null)}}
        ></FullAnalysisFolderSettings>*/}
    </div>
}